import type React from 'react';
import { CaretRightIcon } from '../icons';
import { triggerButton, triggerText } from './moduleTrigger.styles';

export type ModuleTriggerProps = {
  children: React.ReactNode;
  'aria-label': string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * ModuleTrigger - Reusable text-based trigger for module overlays
 *
 * Provides consistent text-based styling for module triggers across HALO.
 * Designed to work with FullscreenOverlay.Trigger via asChild pattern.
 *
 * Features:
 * - Text-based appearance (no button background)
 * - Automatic CaretRightIcon
 * - Full accessibility support
 * - Hover animations
 */
export const ModuleTrigger = ({
  children,
  'aria-label': ariaLabel,
  className,
  onClick,
  onKeyDown,
  ...props
}: ModuleTriggerProps) => {
  return (
    <button
      className={`${triggerButton} ${className || ''}`}
      aria-label={ariaLabel}
      onClick={onClick}
      onKeyDown={onKeyDown}
      {...props}
    >
      <span className={triggerText}>{children}</span>
      <CaretRightIcon />
    </button>
  );
};
